<!--
 * @Author: zjw
 * @Date: 2021-05-18 10:57:34
 * @LastEditTime: 2023-04-04 17:20:25
 * @FilePath: \web-app\src\components\common\Sildebar.vue
 * @Environment: Vue + Element
 * @Description: 侧边栏组件
-->
<template>
    <div class="sildebar">
        <!-- menu导航功能菜单 -->
        <el-menu
            class="el-menu-vertical-demo"
            background-color="#304156"
            text-color="#bfcbd9"
            active-text-color="#409eff"
            collapse-transition
            router
            unique-opened
            :default-active="$route.path"
            :collapse="opened"
            @open="handleOpen"
            @close="handleClose"
        >
            <!-- 内嵌的子菜单栏目 -->
            <sidebar-item
                v-for="(route, index) in roleMenuList"
                :key="index"
                :menuList="route"
            />
        </el-menu>
    </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import SidebarItem from "./SidebarItem";
import mainApi from "network/mainApi";
export default {
    name: "Sidebar",
    components: {
        SidebarItem,
    },
    data() {
        return {};
    },
    computed: {
        ...mapState(["roleMenuList", "opened"]),
    },
    watch: {
        opened: {
            handler(value) {},
            immediate: true,
        },
    },
    created() {
        this.getMenuList(); //获取菜单
        // 每次刷新获取用户信息
        this.getUserRoles();
    },
    methods: {
        ...mapMutations(["setRoleMenuList"]),
        ...mapActions(["getMenuList", "getUserRoles"]),
        handleOpen(key, keyPath) {
            //菜单展开事件
            // console.log(key, keyPath);
        },
        handleClose(key, keyPath) {
            //菜单收起事件
            // console.log(key, keyPath);
        },
    },
};
</script>

<style scoped lang='scss'>
/* 折叠前的宽高 */
.el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 210px;
    height: 100%;
    background-color: #d3dce6;
    overflow: hidden;
    overflow-y: auto;
    &::-webkit-scrollbar {
        width: 0px;
    }
}
// 当屏幕宽度大于1928的时候默认为210px
@media screen and (min-width: 1920px) {
    .el-menu-vertical-demo:not(.el-menu--collapse) {
        width: 210px;
    }
}
/* 折叠后的高度 */
.sildebar {
    background: #304156;
    height: 100%;
}

.sildebar::-webkit-scrollbar {
    width: 0px;
}

/* 去掉折叠后的border边框 */
.el-menu {
    border: none;
}

.logobox {
    height: 80px;
    text-align: center;
    padding: 20px 0px;
}

.logoimg {
    height: 40px;
}
</style>
